import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router';
import './index.css';
import ErrorBoundary from './components/common/ErrorBoundary';
import LoadingSpinner from './components/common/LoadingSpinner';
import ScrollToTop from './components/common/ScrollToTop';
import Seo from './components/common/Seo';
import { ROUTES } from './constants/routes';
import { AuthProvider } from './contexts/AuthContext';

// Lazy load route components
const Home = lazy(() => import('./pages/Home'));
const Impressum = lazy(() => import('./pages/Impressum'));
const Challenger = lazy(() => import('./pages/Challenger'));
const Address = lazy(() => import('./pages/Address'));
const GalleryPage = lazy(() => import('./pages/GalleryPage'));
const GalleryAlbumPage = lazy(() => import('./pages/GalleryAlbumPage'));
const AktuellesPage = lazy(() => import('./pages/AktuellesPage'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminPage = lazy(() => import('./pages/AdminPage'));
const AdminAktuellesPage = lazy(() => import('./pages/AdminAktuellesPage'));
const AdminGalleryPage = lazy(() => import('./pages/AdminGalleryPage'));
const DatenschutzApp = lazy(() => import('./pages/DatenschutzApp'));
const BuchungPage = lazy(() => import('./pages/BuchungPage'));
const StornoPage = lazy(() => import('./pages/StornoPage'));
const AdminBuchungenPage = lazy(() => import('./pages/AdminBuchungenPage'));
const AdminFlyerPage = lazy(() => import('./pages/AdminFlyerPage'));

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <AuthProvider>
                <Router>
                    <ScrollToTop />
                    <Seo />
                    <Suspense fallback={<LoadingSpinner />}>
                        <Routes>
                            <Route path={ROUTES.HOME} element={<Home />} />
                            <Route path={ROUTES.IMPRESSUM} element={<Impressum />} />
                            <Route path={ROUTES.CHALLENGER} element={<Challenger />} />
                            <Route path={ROUTES.ADDRESS} element={<Address />} />
                            <Route path={ROUTES.GALLERY} element={<GalleryPage />} />
                        <Route path={ROUTES.GALLERY_ALBUM} element={<GalleryAlbumPage />} />
                        <Route path={ROUTES.AKTUELLES} element={<AktuellesPage />} />
                        <Route path={ROUTES.ADMIN} element={<AdminPage />} />
                        <Route path={ROUTES.ADMIN_AKTUELLES} element={<AdminAktuellesPage />} />
                        <Route path={ROUTES.ADMIN_LOGIN} element={<AdminLogin />} />
                            <Route path={ROUTES.ADMIN_GALLERY} element={<AdminGalleryPage />} />
                            <Route path={ROUTES.DATENSCHUTZ_APP} element={<DatenschutzApp />} />
                            <Route path={ROUTES.VERANSTALTUNGEN} element={<BuchungPage />} />
                            <Route path={ROUTES.STORNO} element={<StornoPage />} />
                            <Route path={ROUTES.ADMIN_BUCHUNGEN} element={<AdminBuchungenPage />} />
                            <Route path={ROUTES.ADMIN_FLYER} element={<AdminFlyerPage />} />
                        </Routes>
                    </Suspense>
                </Router>
            </AuthProvider>
        </ErrorBoundary>
    </React.StrictMode>
);